<template>
    <div>
        <v-color-picker
            flat
            v-model="color"
            dot-size="8"
            hide-canvas
            hide-inputs
            hide-mode-switch
            @update:color="update($event)"
            style="margin: auto"
        ></v-color-picker>
    </div>
</template>
<script>
// Documentation for Instruction Set:
// https://developer.tuya.com/en/docs/iot/dj?id=K9i5ql3v98hn3#title-9-colour_data_v2
export default {
    props: ['profile', 'value'],
    data() {
        return {
            color: this.convertJsonString(this.value),
            timer: null,
            ignoreChange: true,
            initialized: false
        };
    },
    watch: {
        value(newVal) {
            if (!this.ignoreChange) {
                this.color = this.convertJsonString(newVal);
            }
        }
    },
    methods: {
        update() {
            /* The purpose of this.initialized:
             *
             * This is a "fix" for the vuetify color-picker component.
             * The component does have an Event @update:color, which fires as soon as the slider moves.
             * I use this event to send the new color when the slider was moved.
             * In the beginning, i have to set the color of this slider to display correctly,
             * which fires the update event, which then turns on the Lamp due to a color change
             * since it is implemented this way in the Philips HUE Module on the Controller.
             * To prevent firing events on load, i have added this variable.
             * This can be removed when we replace the vuetify color-picker with the new,
             * self made color-picker which also supports saturation and color-temperature.
             */
            if (this.initialized) {
                if (this.timer == null) {
                    this.timer = setTimeout(() => {
                        const value = JSON.parse(JSON.stringify(this.color));
                        value.s = value.s * 1000;
                        value.v = value.v * 1000;
                        this.ignoreChange = true;
                        this.$emit('execute', JSON.stringify(value));
                        clearTimeout(this.timer);
                        this.timer = null;
                    }, 1000);
                }
            }
            this.initialized = true;
        },
        convertJsonString(jsonString) {
            let hslaValue = {
                h: 0,
                s: 1,
                v: 1
            };
            if (jsonString) {
                const hslaValue = {
                    ...JSON.parse(jsonString)
                };
                hslaValue.s = hslaValue.s / 1000;
                hslaValue.v = hslaValue.v / 1000;
            }
            return hslaValue;
        }
    }
};
</script>

<style>
.v-color-picker {
    background-color: rgba(0, 0, 0, 0) !important;
    max-width: 100% !important;
}
.v-color-picker__dot {
    max-width: 20px;
    max-height: 20px;
}
</style>
